import { ProductIcon, ProductIconGlyph } from "./product-icon";
export var TechnologyIcon = ProductIcon;
export var TechnologyIconGlyph = ProductIconGlyph;